import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from 'styled-components';
export var menuSwitcherButtonStateStyles = {
  active: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.color.gray[300].value;
  }),
  focus: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: 0 0 0 4px ", ";\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.color.gray[200].value;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.color.gray[800].value;
  }),
  hover: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.color.gray[200].value;
  })
};